<template>
  <div class="flex flex-col space-y-2 bg-gray-50 px-6 py-4 rounded-xs">
    <div v-for="(_, key) in translations" :key="key">
      <div v-if="key !== locale">
        <div class="flex items-center justify-between">
          <span class="text-sm font-medium text-gray-600">
            {{ t(`validation.values.locale.${key}`) }}
          </span>
          <input
            class="text-ellipsis bg-transparent border-2 border-transparent text-sm font-semibold text-gray-900 rounded-sm"
            type="text"
            :disabled="disabled"
            :class="{
              'cursor-not-allowed': disabled,
              'focus:bg-white focus:border-gray-500 hover:border-gray-500 hover:bg-white focus:ring-0':
                !disabled,
            }"
            v-model="translations[key]"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { usePage } from "@inertiajs/vue3";
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
  value: Object,
  disabled: Boolean,
});

const emit = defineEmits(["change"]);

const translations = ref(props.value);

const { t } = useI18n();
const locale = usePage().props.locale;

watch(translations, (value) => {
  emit("change", value);
});
</script>
